export default "__VITE_ASSET__DlI3jZYH__"